/**
 * Browser storage keys shared between AICA sessionStorage and localStorage.
 * Centralized so callers (helpers, interceptors, integrations) cannot drift.
 */
export const STORAGE_KEYS = {
    AUTH_TOKEN: 'auth_token',
    ORG_ID: 'org_id',
    USER_ID: 'user_id',
} as const;
